import type { HomeDayChange } from './types';
import { InfoBubble } from '../common/info-bubble';
import { HOME_DAY_CHANGE_TOOLTIP_LABEL } from './constants';
import { dayChangeTooltip } from './utils';

export function DayChangeTooltip({ dayChange }: { readonly dayChange: HomeDayChange }) {
  return <InfoBubble label={HOME_DAY_CHANGE_TOOLTIP_LABEL}>{dayChangeTooltip(dayChange)}</InfoBubble>;
}
